import { render, staticRenderFns } from "./RightBet.vue?vue&type=template&id=45a66a08&scoped=true&"
import script from "./RightBet.vue?vue&type=script&lang=js&"
export * from "./RightBet.vue?vue&type=script&lang=js&"
import style0 from "./RightBet.vue?vue&type=style&index=0&id=45a66a08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a66a08",
  null
  
)

export default component.exports